import api from './api';

export async function uploadChunkingDocument(
  file,
  systemMessage,
  responseFormat,
  enableSealDetection = false,
  reducerModel = null
) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append(
    'request',
    JSON.stringify({
      system_message: systemMessage,
      response_format: responseFormat,
      enable_seal_detection: !!enableSealDetection,
      ...(reducerModel ? { reducer_model: reducerModel } : {}),
    })
  );
  const headers = {};
  const response = await api.post('/v1/documents', formData, { headers });
  return response.data;
}

export async function getChunkingDocumentStatus(docId) {
  const response = await api.get(`/v1/documents/${docId}`);
  return response.data;
}

export async function listChunkingPages(docId) {
  const response = await api.get(`/v1/documents/${docId}/pages`);
  return response.data;
}

export async function fetchChunkingPageArtifact(docId, pageNum, artifactType) {
  const response = await api.get(`/v1/documents/${docId}/pages/${pageNum}/${artifactType}`);
  return response.data;
}

export async function fetchSealDetectionStatus(docId) {
  const response = await api.get(`/v1/documents/${docId}/seals`);
  return response.data;
}

export async function fetchChunkingFinalJson(docId) {
  const response = await api.get(`/v1/documents/${docId}/final`);
  return response.data;
}

export async function fetchChunkingTrace(docId) {
  const response = await api.get(`/v1/documents/${docId}/trace`);
  return response.data;
}

export async function fetchChunkingReductionReport(docId) {
  const response = await api.get(`/v1/documents/${docId}/reduction-report`);
  return response.data;
}

export async function fetchChunkingPagePdf(docId, pageNum, signal) {
  const response = await api.get(`/v1/documents/${docId}/pages/${pageNum}/pdf`, {
    responseType: 'blob',
    headers: { Accept: 'application/pdf' },
    signal,
  });
  // Force the correct MIME type — API gateways sometimes rewrite Content-Type,
  // which makes the browser render the blob as text instead of a PDF.
  return new Blob([response.data], { type: 'application/pdf' });
}

export async function restartChunkingStage(docId, stage) {
  const response = await api.post('/v1/documents/restart', { doc_id: docId, stage });
  return response.data;
}